export default "__VITE_ASSET__e07b9eab__"